import { Backdrop, ClickAwayListener, Modal } from '@material-ui/core';
import React from 'react';
import { useMenuTreeCreator } from './AppDrawerComplexMenuTreeCreator';
import AppDrawerComplexColumn from './AppDrawerComplexColumn';
import AppDrawerComplexColumnGroup from './AppDrawerComplexColumnGroup';

const AppDrawerComplex = React.forwardRef((props, ref) => {
  const { menuDefinition, modal, open, onClose } = props;
  
  const [submenusOpened, setSubmenusOpened] = React.useState([]);
  
  React.useEffect(() => {
    if (!open) {
      setSubmenusOpened([]);
    }
  }, [open]);
  
  const forceClose = React.useCallback(event => {
    setSubmenusOpened([]);
    onClose(event);
  }, [onClose]);
  
  const createMenuTree = useMenuTreeCreator(menuDefinition);
  const submenusOpenedTree = createMenuTree(submenusOpened);
  
  const drawer = (
    <AppDrawerComplexColumnGroup
      ref={ref}
      open={open}
      modal={modal}
    >
      {submenusOpenedTree.map((currentMenu, index) => (
        <AppDrawerComplexColumn
          key={`drawer-child-${index}`}
          dark={index === 0}
          modal={modal}
          menuDefinition={currentMenu}
          submenuOpened={submenusOpened[index]}
          onClick={forceClose}
          onSubmenuClick={submenuIndex => {
            const currentSubmenuIndex = submenusOpened[index];
            const currentSubmenusOpened = submenusOpened.slice(0, index);
            if (submenuIndex !== currentSubmenuIndex) {
              currentSubmenusOpened.push(submenuIndex);
            }
            setSubmenusOpened(currentSubmenusOpened);
          }}
        />
      ))}
    </AppDrawerComplexColumnGroup>
  );
  
  if (modal) {
    return (
      <Modal
        open={open}
        onClose={onClose}
        BackdropComponent={Backdrop}
      >
        {drawer}
      </Modal>
    );
  }
  
  return (
    <ClickAwayListener onClickAway={forceClose}>
      {drawer}
    </ClickAwayListener>
  );
});

export default AppDrawerComplex;
